import EnabledColumns from './enabled_columns_app'

export default { EnabledColumns }
